import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';

const PrivateAdminRoute = ({ children }) => {
  const { isAdminLogged } = useAdminAuth();

    return isAdminLogged ? children : <Navigate to="/admin-login" />;
};

export default PrivateAdminRoute;
